export default __webpack_public_path__ + "static/media/1695387962634--sub_image_0.97ead8f4.jpg";